module.exports = __webpack_public_path__ + "img/co2class.png";